import isTaskDone from './isTaskDone'

/**
 * De nog openstaande projectafspraken, eerstvolgende bovenaan.
 *
 * Afspraken zonder datum staan onderaan: 'nog in te plannen' hoort niet de
 * afspraak van morgen te verdringen.
 *
 * AI-CONTEXT: See docs/features/deccos-projectafspraken.md
 *
 * @template {{Timestamp?: {toDate?: () => Date}|null, Done?: boolean|string}} T
 * @param {Array<T>|null|undefined} tasks
 * @returns {Array<T>}
 */
const sortOpenProjectTasks = (tasks) => {
    if (!Array.isArray(tasks)) return []

    const startOf = (task) => (task?.Timestamp?.toDate ? task.Timestamp.toDate().getTime() : null)

    return tasks
        .filter((task) => !isTaskDone(task))
        .sort((a, b) => {
            const left = startOf(a)
            const right = startOf(b)

            if (left === null && right === null) return 0
            if (left === null) return 1
            if (right === null) return -1

            return left - right
        })
}

export default sortOpenProjectTasks
